export default __webpack_public_path__ + "static/media/pic3.3e0c865e.jpg";